import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

function SectionExtra() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div id="" className="sectionExtra">
        <div className={`count1 count ${isVisible ? "visible" : ""}`}>
          <p className="number">{t("lp5_stat1_number")}</p>
          <p className="text">{t("lp5_stat1_text")}</p>
        </div>
        <div className={`count2 count ${isVisible ? "visible" : ""}`}>
          <p className="text">{t("lp5_stat2_text")}</p>
          <p className="number">{t("lp5_stat2_number")}</p>
        </div>
        <div className={`count3 count ${isVisible ? "visible" : ""}`}>
          <p className="number">{t("lp5_stat3_number")}</p>
          <p className="text">{t("lp5_stat3_text")}</p>
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default SectionExtra;
